<template>
  <div>
    <div class="text-center" v-if="!dataLoaded">
      <v-progress-circular class="mt-6" :size="50" color="primary" indeterminate />
    </div>

    <div class="mt-1" v-show="dataLoaded">
      <v-row>
        <v-col cols="12" class="d-flex align-end justify-space-between">
          <v-btn
            small
            outlined
            color="primary"
            class="white--text px-4"
            @click="dialog = true"
          >
            <v-icon left small>mdi-plus</v-icon>Добавить
          </v-btn>
        </v-col>
      </v-row>

      <PageTable
        :table-loading="tableLoading"
        :table-headers="tableHeaders"
        :table-items="genders.list"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon color="lightGrey" class="mr-2 eye-btn" size="22" title="Просмотр" @click="show(item)">
            mdi-eye-outline
          </v-icon>
          <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="edit(item)">
            mdi-pencil-outline
          </v-icon>
          <v-icon color="lightGrey" class="remove-btn" size="22" title="Удалить" @click="remove(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
      </PageTable>
    </div>

    <GenderDialog
      :dialog="dialog"
      :saveBtnLoading="btnLoading"
      :selectedItem="selectedItem"
      :isShowMode="isShowMode"
      @saveGender="saveGender"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Вы уверены, что хотите удалить значение из справочника?`"
      @confirm="removeGender"
      @closeModal="closeDialog"
    />
  </div>
</template>

<script>
import { genderApi } from '@/api'
import { Genders } from '@/models'
import PageTable from '@/components/ui/Table'
import GenderDialog from '@/components/zvp/dictionaries/gender/dialogs/Gender'
import ConfirmDialog from '@/components/dialogs/ConfirmDelete'

export default {
  name: 'Gender',

  components: {
    PageTable,
    GenderDialog,
    ConfirmDialog
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')
    await this.getGroups()
    this.dataLoaded = true
  },

  data: () => ({
    tableHeaders: [
      { text: 'Пол', value: 'name', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '130px' }
    ],
    genders: new Genders(),
    dataLoaded: false,
    tableLoading: false,
    selectedItem: null,
    isShowMode: false,
    dialog: false,
    confirmDialog: false,
    btnLoading: false
  }),

  methods: {
    async getGroups() {
      const data = await genderApi.getCatalog()
      if(data) data.forEach(obj => this.genders.addGender(obj))
    },

    async saveGender(body) {
      try {
        this.btnLoading = true

        const data = body.id ? await genderApi.updateGender(body) : await genderApi.createGender(body)
        body.id ? this.genders.updateGender(data) : this.genders.addGender(data)

        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.btnLoading = false
      }
    },

    async removeGender() {
      try {
        this.btnLoading = true

        await genderApi.removeGender(this.selectedItem.id)
        this.genders.removeGender(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.btnLoading = false
      }
    },

    show(item) {
      this.selectedItem = item
      this.dialog = true
      this.isShowMode = true
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.confirmDialog = false
      this.selectedItem = null
      this.isShowMode = false
    },
  },
}
</script>

<style scoped>
</style>
